module.exports = __webpack_public_path__ + "img/grid-view.a7bc0168.svg";